import { HttpHeaders,HttpResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

import { ServicioApiService } from './servicio-api.service';
import { IResponseData } from '../nucleo/interface/dto/IResponseData';
import { Constante } from '../nucleo/constante/constante';
import { IRequestData } from '../nucleo/interface/dto/IRequestData';
import { IDocumentoDto } from '../nucleo/interface/dto/IDocumentoDto';


@Injectable()

export class ServicioService {

    constructor(private servidorApi: ServicioApiService) {

    }

    consultar<FILTRO, ENTIDAD>(path: string, requestData: IRequestData<FILTRO, ENTIDAD>, opcion: string): Observable<IResponseData> {
        return this.servidorApi.consultar(path, requestData, {
            headers: new HttpHeaders({
                'auth-access': '',
                'auth-option': opcion,
                'auth-type': Constante.TYPE_OPCION
            })
        });
    }

    descargar(path: string, documentoDto: IDocumentoDto): Observable<Blob> {
        return this.servidorApi.descargar(path, documentoDto, {
            headers: new HttpHeaders({
                'auth-type': Constante.TYPE_SERVICIO
            }),
            responseType: 'blob' as 'json'
        });
    }

}
